import React from 'react';
import { motion } from 'framer-motion';
import { Target, AlertTriangle, Trophy, Clock, CheckCircle2, XCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TargetAudience() {
  const forWho = ['Kinesiólogos y fisioterapeutas', 'Médicos traumatólogos', 'Profesionales en rehabilitación', 'Estudiantes avanzados', 'Clínicas y centros de salud'];
  const notForWho = ['Personas que no aplican lo que aprenden', 'Profesionales que no quieren mejorar', 'Quienes prefieren seguir improvisando'];
  const results = ['Más preciso', 'Más confiable', 'Más eficiente', 'Mejor posicionado', 'Mejor pago'];
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-173">
      <div className="max-w-5xl mx-auto" data-id="element-174">
        <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-175">
          {/* Para quién es */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 p-8 rounded-3xl border border-teal-900/50 relative overflow-hidden" data-id="element-176">
            <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/10 rounded-full blur-2xl" data-id="element-177"></div>
            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-178">
              <Target className="w-8 h-8 text-teal-400" data-id="element-179" />
              <h2 className="text-3xl font-bold text-white" data-id="element-180">¿Para quién es?</h2>
            </div>
            <ul className="space-y-4 mb-8 relative z-10" data-id="element-181">
              {forWho.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-182">
                  <CheckCircle2 className="w-6 h-6 text-teal-500 flex-shrink-0" data-id="element-183" />
                  <span className="text-slate-200 text-lg" data-id="element-184">{item}</span>
                </li>)}
            </ul>
            <div className="bg-teal-950/50 p-4 rounded-xl border border-teal-900 relative z-10" data-id="element-185">
              <p className="font-bold text-teal-400 text-center" data-id="element-186">
                👉 Si querés trabajar mejor, esto es para vos.
              </p>
            </div>
          </motion.div>

          {/* Para quién NO es */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 p-8 rounded-3xl border border-red-900/30 relative overflow-hidden" data-id="element-187">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-full blur-2xl" data-id="element-188"></div>
            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-189">
              <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-190" />
              <h2 className="text-3xl font-bold text-white" data-id="element-191">
                ¿Para quién NO es?
              </h2>
            </div>
            <ul className="space-y-4 relative z-10" data-id="element-192">
              {notForWho.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-193">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-194" />
                  <span className="text-slate-300 text-lg" data-id="element-195">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Resultado Final */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-197">
            <div className="flex items-center gap-3 mb-6" data-id="element-198">
              <Trophy className="w-10 h-10 text-amber-500" data-id="element-199" />
              <h2 className="text-4xl font-black text-white" data-id="element-200">
                Resultado final
              </h2>
            </div>
            <p className="text-2xl text-slate-300 mb-8" data-id="element-201">
              Te convertís en un profesional:
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-202">
              {results.map((item, i) => <span key={i} className="bg-slate-800 text-white px-5 py-2 rounded-lg font-bold border border-slate-700 flex items-center gap-2" data-id="element-203">
                  <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-204" /> {item}
                </span>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-teal-900/40 to-slate-900 p-8 rounded-3xl border border-teal-800/50" data-id="element-205">
            <div className="flex items-center gap-3 mb-6" data-id="element-206">
              <Clock className="w-8 h-8 text-teal-400" data-id="element-207" />
              <h3 className="text-2xl font-bold text-white" data-id="element-208">
                En menos de 7 días podés notar el cambio
              </h3>
            </div>
            <p className="text-lg text-slate-300 mb-6" data-id="element-209">
              Vas a empezar a trabajar con:
            </p>
            <ul className="space-y-3 mb-8" data-id="element-210">
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-211">
                <CheckCircle2 className="w-6 h-6 text-teal-500" data-id="element-212" /> Más orden
              </li>
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-213">
                <CheckCircle2 className="w-6 h-6 text-teal-500" data-id="element-214" /> Más claridad
              </li>
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-215">
                <CheckCircle2 className="w-6 h-6 text-teal-500" data-id="element-216" /> Más control
                sobre tus pacientes
              </li>
            </ul>
            <p className="text-xl font-bold text-amber-400" data-id="element-217">
              👉 Y eso impacta directamente en tus resultados.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-218">
          <CTAButton data-id="element-219" />
        </motion.div>
      </div>
    </section>;
}